export default class DiscountModule {
    locale = null;
    settings = null;
    notification = null;
    calculator = null;
    disabled = false;

    input = document.querySelector('.discount-code input');
    button = document.querySelector('.discount-code button');
    touristWithoutLoyalityProgramModal = document.getElementById('touristWithoutLoyalityProgram');
    button_joinLP = this.touristWithoutLoyalityProgramModal.querySelector('.button-joinLP');
    button_login = this.touristWithoutLoyalityProgramModal.querySelector('.button-login');

    constructor(locale, settings, notification, calculator, disabled = false) {
        this.locale = locale;
        this.settings = settings;
        this.notification = notification;
        this.calculator = calculator;
        this.disabled = disabled;
        this.setStatus();
        this.bindDiscountCodeButton();
        this.bindJoinLPButtonOnModal();
        if (this.calculator.isNonRefundableOfferEnabled()) {
            this.calculator.nonRefundableOffer.classList.add('active');
        }
    }

    setStatus = () => {
        this.input.disabled = this.disabled;
        this.button.disabled = this.disabled;
    }

    bindDiscountCodeButton = () => {
        const { checkDiscountCodeUrl } = this.settings;
        const { input, button } = this;

        button.addEventListener('click', async () => {
            if (this.disabled) {
                this.notification.show(this.notification.types.error, this.locale.codeCannotBeUsed);
                return;
            }

            console.log(`checkDiscountCodeUrl: ${checkDiscountCodeUrl}`);
            const response = await fetch(checkDiscountCodeUrl + input.value, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'X-Requested': 'With: XMLHttpRequest'
                }
            });
            const res = await response.json();

            if (res.DiscountValid) {
                if (res.IsLoyaltyProgramPersonalCode && res.IsLoyaltyProgramReferralCode) {
                    this.notification.show(this.notification.types.error, this.locale.wrongDiscountCode);
                    return;
                }
                if (res.NumberOfDays == 1) {
                    modal.open('usedOnOneDayOrder');
                    return;
                }
                if (!res.IsLoyaltyProgramPersonalCode && !res.IsLoyaltyProgramReferralCode) {
                    if (!res.IsUsedByTouristInLoyalityProgram && !res.IsUsedByTouristWithoutLoyalityProgram) {
                        this.notification.show(this.notification.types.error, this.locale.wrongDiscountCode);
                        return;
                    }
                    if (this.calculator.currentUserIsInLoyaltyProgram && !res.IsUsedByTouristInLoyalityProgram) {
                        modal.open('touristInLoyalityProgram');
                        return;
                    }
                    if (!this.calculator.currentUserIsInLoyaltyProgram && !res.IsUsedByTouristWithoutLoyalityProgram) {
                        if (this.settings.currentUserId > 0) {
                            if (this.button_joinLP.classList.contains('hide-elements')) {
                                this.button_joinLP.classList.remove('hide-elements');
                            }
                            this.button_login.classList.add('hide-elements');
                        } else {
                            if (this.button_login.classList.contains('hide-elements')) {
                                this.button_login.classList.remove('hide-elements');
                            }
                            this.button_joinLP.classList.add('hide-elements');
                        }
                        modal.open('touristWithoutLoyalityProgram');
                        return;
                    }
                }

                if (res.DiscountValue < 1) {
                    this.calculator.valueProcentage = res.DiscountValue;
                } else {
                    this.calculator.value = res.DiscountValue;
                }
                this.calculator.isUsed = true;
                this.calculator.isTotalDiscount = res.IsTotalDiscount;

                document.getElementById('DiscountCode').value = input.value;
                let discountCode = document.getElementById('discount-code');
                discountCode.classList.add('d-none');

                this.notification.show(this.notification.types.success, this.locale.correctDiscountCode + ` ${input.value}`);
            } else {
                if (res.UsedVoucher) {
                    this.notification.show(this.notification.types.error, this.locale.usedVoucherCode);
                }
                else if (res.NumberOfDays == 1) {
                    modal.open('usedOnOneDayOrder');
                }
                else {
                    this.notification.show(this.notification.types.error, this.locale.wrongDiscountCode);
                }
            }

            this.calculator.calculateReservationCost();
        });
    }

    bindJoinLPButtonOnModal = () => {

        this.button_joinLP.addEventListener('click', () => {
            modal.close('touristWithoutLoyalityProgram');
            location.href = '/Account/Index?open=loyaltyProgramForm';
        });

        this.button_login.addEventListener('click', () => {
            modal.close('touristWithoutLoyalityProgram');
            modal.open('login');
        });
    }

    formatValue = (value) => {
        return value.toFixed(2).replace('.', ',');
    }
}